import { useReduxState } from 'hooks';

interface Props {
  children: React.ReactNode;
  inline?: boolean;
}

const BoxTable = ({ children, inline = false }: Props) => {
  const { theme } = useReduxState();

  return (
    <div className={`box-table ${inline ? 'inline' : ''}`}>
      {children}

      <style jsx>{`
        .box-table {
          display: table;
          border-collapse: collapse;
          width: 100%;
        }
        .inline {
          border-radius: ${theme.cardBorderRadius};
          box-shadow: 0 0 0 1px ${theme.lightGrey};
        }
      `}</style>
    </div>
  );
};

export default BoxTable;
